import { useState } from 'react';
import styles from './ContInfo.module.css';
import avatarPlaceholder from '../../assets/icons/avatar.svg';
import copyIcon from '../../assets/icons/copy.svg';
import { buildDisplayName } from '../../utils/userDisplay';
import { getRoleLabel } from '../../utils/roles';

const CopyableField = ({ label, value }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch {
      setIsCopied(false);
    }
  };

  return (
    <div
      className={styles.detailItem}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={styles.detailLabel}>{label}:</span>
      <span className={styles.detailValue}>{value}</span>
      {isHovered && (
        <button className={styles.copyButton} onClick={handleCopy} title={isCopied ? 'Скопировано!' : 'Копировать'}>
          <img src={copyIcon} alt="copy" className={styles.copyIcon} />
          {isCopied && <span className={styles.copiedText}>Скопировано!</span>}
        </button>
      )}
    </div>
  );
};

export const ContInfo = ({ profile, onWantTeamToggle, wantTeamPending = false }) => {
  const selectionStatus = profile?.selection_status || {
    code: null,
    label: 'Заявка на отбор не найдена',
    description: 'По нашим данным, вы не подавали заявку на отбор в интенсив.',
    is_in_selection_table: false,
  };
  const selectionToneClass = !selectionStatus.is_in_selection_table
    ? styles.selectionStatusMissing
    : selectionStatus.code === 'NOT_SELECTED'
      ? styles.selectionStatusDanger
      : selectionStatus.code === 'CANDIDATE'
        ? styles.selectionStatusWarning
        : styles.selectionStatusSuccess;
  const userData = {
    avatar: profile?.avatar_url || avatarPlaceholder,
    fullName: buildDisplayName(profile) || 'Пользователь',
    login: profile?.login || '-',
    publicCode: profile?.public_code || '-',
    email: profile?.email || '-',
    role: getRoleLabel(profile?.role) || '-'
  };

  return (
    <div className={styles.contInfo}>
      <div className={styles.avatarBlock}>
        <img
          src={userData.avatar}
          alt="Аватар"
          className={styles.avatar}
          onError={(event) => {
            event.currentTarget.src = avatarPlaceholder;
          }}
        />
      </div>
      <div className={styles.info}>
        <div className={styles.topRow}>
          <div className={styles.identityBlock}>
            <span className={styles.fullName}>{userData.fullName}</span>
            <span className={styles.loginText}>@{userData.login}</span>
            {profile?.want_team ? (
              <span className={styles.wantTeamBadge}>Хочу в команду</span>
            ) : null}
          </div>
          {onWantTeamToggle ? (
            <label className={styles.wantTeamToggle}>
              <span className={styles.toggleText}>Хочу в команду</span>
              <input
                type="checkbox"
                checked={Boolean(profile?.want_team)}
                onChange={(event) => onWantTeamToggle(event.target.checked)}
                disabled={wantTeamPending}
              />
              <span className={styles.toggleTrack}>
                <span className={styles.toggleThumb} />
              </span>
            </label>
          ) : null}
        </div>
        <div className={styles.details}>
          <CopyableField label="Код участника" value={userData.publicCode} />
          <CopyableField label="Почта" value={userData.email} />
          <CopyableField label="Статус на платформе" value={userData.role} />
        </div>
        <div className={`${styles.selectionStatus} ${selectionToneClass}`}>
          <span className={styles.selectionStatusLabel}>Статус отбора</span>
          <strong className={styles.selectionStatusValue}>{selectionStatus.label}</strong>
          <p className={styles.selectionStatusDescription}>{selectionStatus.description}</p>
        </div>
      </div>
    </div>
  );
};
